import { render } from "./StockTable.vue?vue&type=template&id=e9ae58e4&scoped=true"
import script from "./StockTable.vue?vue&type=script&lang=js"
export * from "./StockTable.vue?vue&type=script&lang=js"

import "./StockTable.vue?vue&type=style&index=0&id=e9ae58e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9ae58e4"]])

export default __exports__